import { render, staticRenderFns } from "./JobAdd.vue?vue&type=template&id=921e36e8&"
import script from "./JobAdd.vue?vue&type=script&lang=ts&"
export * from "./JobAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "JobAdd.vue"
export default component.exports